site.owl = {
	counter: 0,
	// Shorthand to init owlcarousel
	init: function(id, options) {
		let $owl = $(id);
		if ($owl.length > 1) {
			$owl.each(function() {
				let $this = $(this);
				if (!$this.attr('id')) {
					$this.attr('id', 'carousel_' + site.owl.counter);
					site.owl.counter++;
				}
				site.owl.init('#' + $this.attr('id'), options);
			});
			return false;
		}
		if ($owl.length === 1) {
			let opt = Object.assign({}, options);
			if ($owl.data('loop') === 1) {
				opt.loop = true;
			}
			if ($owl.data('startposition')) {
				opt.startPosition = $owl.data('startposition');
			}
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(opt);
		}
	}
};

site.OpenFancyBox = {
	init: function() {
		$().click(function (e) {
			e.preventDefault();
			$.fancybox($("a.fancybox"));
		});
	}
};

site.accessibility = {
	init:function() {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	}
};

site.qn = {
	init:function() {
		const banner = document.getElementById('notfication-banner');
		const closeBtn = document.getElementById('close-notification');
		const qn = document.getElementById('qn');
		if (!qn) {
			return;
		}

		if (closeBtn) {
			qn.classList.add('notification-showing');
			closeBtn.addEventListener('click', function( event ) {
				qn.classList.add('notification-closed');
				qn.style.transition = 'top .6s ease';
				qn.style.transitionDelay = '.1s';
			}, false);
		}

		if (!banner) {
			qn.classList.add('notification-hidden');
		}
	},
}

site.svg = {
	init: function () {
		$('.icon.svg').each(function() {
			let icon = $(this).data('icon');
			if (icon && icon.length) {
				let style = "url('/static/files/icons/" + icon + ".svg') no-repeat center / contain;";
				$(this).attr('style', "-webkit-mask: " + style + "mask: " + style);
			}
		});
	}
};

site.carousel = {
	init: function () {
		site.owl.init('.carousel__horizontal:not(.list)', {
			loop: false,
			dots: false,
			margin: 30,
			animateOut: 'fadeOut',
			animateIn: 'fadeIn',
			nav: true,
			navText: ["", ""],
			responsive: {
				0: {
					items: 1,
				},
				768: {
					items: 2,
				},
				992: {
					items: 3,
				},
				1200: {
					items: 4,
				}
			},
		});

		site.owl.init('.image__carousel__items', {
			items: 1,
			loop: true,
			nav: true,
			dots: false,
			margin: 0,
			center: true,
			navText: ["", ""],
			smartSpeed: 800,
		});

		site.owl.init('.information.carousel', {
			loop: false,
			dots: false,
			margin: 2,
			animateOut: 'fadeOut',
			animateIn: 'fadeIn',
			nav: true,
			navText: ["", ""],
			responsive: {
				0: {
					items: 2,
				},
				480: {
					items: 3,
				},
				768: {
					items: 4,
				},
				992: {
					items: 5,
				},
				1200: {
					items: 6,
				}
			},
		});
	}
};

site.toyImages = {
	init: function() {
		$('.carousel__view .imageWrapper .image').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			fade: true,
			draggable: false,
			asNavFor: '.carousel__view .imageWrapper .album',
			lazyLoad: 'ondemand',
		});
		$('.carousel__view .imageWrapper .album').slick({
			slidesToShow: 3,
			slidesToScroll: 1,
			asNavFor: '.carousel__view .imageWrapper .image',
			centerMode: true,
			focusOnSelect: true,
			vertical: true,
			infinite: true,
			draggable: false,
			centerPadding: 0,
			lazyLoad: 'ondemand',
			responsive: [
				{
					breakpoint: 992,
					settings: {
						vertical: false,
					}
				},
				{
					breakpoint: 776,
					settings: {
						slidesToShow: 2,
						vertical: false,
					}
				},
			]
		});
	},
};

site.megamenu = {
	sidebar: function() {
		$('#mainmenu .level1:not(.hidden-lg) .megamenu .mmLevel2').each(function(i) {
			let $this = $(this);
			let level3Count = $('.level2', this).length;
			if (level3Count > 3) {
				let columnCount = $('.level2:nth-child(4)', $this).hasClass('children') ? 4 : 3
				$this.closest('.megamenu').addClass('hasSidebar');
				let $sidebar = $this.clone();
				$sidebar.removeAttr('id').addClass('sidebar');
				$(`.level2:nth-child(-n+${columnCount})`, $sidebar).remove();
				$(`.level2:nth-child(n+${columnCount + 1})`, $this).remove();
				$this.after($sidebar);
			}
		});
	},

	seeAll: function() {
		$.ajax({
			type: 'get',
			url: '/_/' + document.querySelector('html').getAttribute('lang') + '/toy/ajax/megamenu',
			dataType: 'json',
			success: function (data) {
				for (let key in data) {
					if (!data.hasOwnProperty(key)) {
						continue;
					}
					let $level2 = $('#mainmenu .megamenu .mmLevel2:not(.sidebar) .children.ele-'  + key);
					let $mm3 = $('.mmLevel3', $level2);
					if ($mm3.length && data[key]) {
						let href = $('> a', $level2).attr('href');
						$mm3.append('<li class="level3 seeAll"><a href="' + href + '"><span>' + data[key] + '</span></a>');
						$('> a span', $level2).unwrap();
					}

					let $mobileLevel2 = $('#mobilemenu .mmLevel2:not(.sidebar) .children.ele-'  + key);
					let $mobilemm3 = $('.mmLevel3', $mobileLevel2);
					if ($mobilemm3.length && data[key]) {
						let mobilehref = $('> a', $mobileLevel2).attr('href');
						$mobilemm3.append('<li class="level3 seeAll"><a href="' + mobilehref + '"><span>' + data[key] + '</span></a>');
					}
				}
			}
		});
	}
};

site.map = {
	init: function() {
		if (!$('div.map__wrap').length) {
			return false;
		}

		const map = moya.map.osmMap;

		if (!map || !moya.map.markers.length) {
			return false;
		}

		const markers = moya.map.markers;
		moya.map.activeMarkers = markers;
		const oms = new OverlappingMarkerSpiderfier(map, {
			keepSpiderfied: true
		});
		for (let i in markers){
			oms.addMarker(markers[i]);
		}
		let zoomLevel = markers[0].options.type === 'municipality' ? 10 : 16;
		oms.addListener('spiderfy', function(markers) {
			map.closePopup();

			if (map._zoom < zoomLevel) {
				site.map.fitBounds(zoomLevel);
			}
		});

		$('body').on('click', 'button.togglePopup', function () {
			let $this = $(this);
			map.closePopup();
			if (window.matchMedia("only screen and (max-width: 991px)").matches) {
				$('html,body').animate({
					scrollTop: $('.moyaMap').offset().top - 65
				}, 1000);
			}
			for (let i in moya.map.activeMarkers) {
				let marker = moya.map.activeMarkers[i];
				if (marker.options.key && marker.options.key === $this.data('key')) {
					if (map._zoom < zoomLevel) {
						map.setView(marker._latlng, zoomLevel);
					}
					marker.openPopup();
					return;
				}
			}
		});
		site.map.categories();

		if (!location.hash.slice(1) && $('.map__wrap').hasClass('full')) {
			$('#moya-select-mapCategories-list li:first-child').trigger('click')
		}
		if (location.search.includes('?view=map')) {
			$('html,body').animate({
				scrollTop: $('.moyaMap').offset().top - 65
			}, 1000);
		}
	},

	categories: function() {
		const mapSubCategories = document.querySelector('.mapSubCategories');
		const mapSubCategoriesAll = mapSubCategories.querySelector('a.all');
		const mapCategories = $('#mapCategories');
		const fullMapBaseUrl = mapCategories.data('baseurl');

		//Only add parent codename as hash on click
		$('#moya-select-mapCategories-list li').on('click', function(e) {
			if (e.originalEvent !== undefined && !fullMapBaseUrl) {
				let codename = $(this).attr('id').replace('moya-select-mapCategories-', '');
				let hash = codename !== 'all' && codename !== 'municipality' ? codename : '';
				history.pushState(null, null, '#' + hash);
			}
		});

		//Parent categories has changed
		mapCategories.on('change', function(e) {
			if (fullMapBaseUrl) {
				window.location = fullMapBaseUrl + this.value;
				e.stopPropagation();
				return false;
			}
			let isAll = true;
			mapSubCategories.classList.add('hidden');
			document.querySelectorAll('.mapSubCategories a:not(.all)').forEach(e => e.parentNode.removeChild(e));
			let classList = [];
			if (this.value === 'municipality') {
				classList.push('municipality');
			}
			else if (this.value !== 'all') {
				mapSubCategoriesAll.setAttribute('href', '#' + this.value)
				let children = $(this).find(':selected').data('children');
				if (children) {
					children.forEach(category => {
						classList.push(parseInt(category.id));
						site.map.createSubCategory(category, mapSubCategories);
					});
					mapSubCategories.classList.remove('hidden');
					if ($('.mapSubCategories .active').attr('href') !== location.hash) {
						isAll = false;
					}

					setTimeout(function() {
						if (!isAll) {
							$('a[href="' + location.hash + '"]').trigger('click');
						}
					}, 1);
				}
				else {
					let key = $(this).find(':selected').data('key');
					key = key !== undefined ? key : this.value;
					classList.push(parseInt(key));
				}
			}

			if (isAll) {
				site.map.updateVisibleData(classList);
			}
		});

		//Subcategories has changed
		$('body').on('click', '.mapSubCategories a', function () {
			let $this = $(this);
			$this.siblings().removeClass('active');
			$this.addClass('active');

			let id = $this.data('id');
			if (id === 0) {
				$('#moya-select-mapCategories-list li.active').trigger('click');
			}
			else {
				site.map.updateVisibleData([id]);
			}
		});

		//Detect category by hash on load - NEEDS REVIEW!
		let selectedCategory = null;

		$(window).bind("hashchange", function (e) {
			let hash = location.hash.slice(1);
			if (hash && $('.mapSubCategories').hasClass('hidden')) {
				let parentCategory = '#moya-select-mapCategories-' + hash;
				if ($(parentCategory).length) {
					selectedCategory = parentCategory;
				}
				else {
					//Check if hash exists in subcategories
					let codenameFound = false;
					$('#mapCategories option').each(function () {
						if (codenameFound) {
							return;
						}
						let children = $(this).data('children');
						if (!children) {
							return;
						}
						let found = children.find(child => child.codename === hash);
						if (found) {
							codenameFound = true;
							selectedCategory = '#moya-select-mapCategories-' + $(this).val();
						}
					});
				}
				if (selectedCategory) {
					$(selectedCategory).trigger('click');
				}
				else {
					site.map.showMap();
				}
			}
			else {
				site.map.showMap();
			}
		}).trigger('hashchange');
	},

	createSubCategory: function(category, mapSubCategories) {
		let a = document.createElement('a');
		a.setAttribute('href', '#' + category.codename);
		a.innerText = category.name;
		a.setAttribute('data-id', category.id);
		mapSubCategories.appendChild(a);
	},

	updateVisibleData: function(tags)
	{
		let map = moya.map.osmMap;
		let markers = map.options.markers;
		moya.map.osmMap.closePopup();

		//Remove current markers
		$.each(map._layers, function() {
			let layer = $(this)[0];
			if (layer._icon || layer._featureGroup) {
				map.removeLayer(layer);
			}
		});

		if (tags.length) {
			//Update sidebar list
			$('.map__list .item').addClass('hidden');
			tags.forEach(id => {
				$('.map__list .item.c' + id).removeClass('hidden');
			});

			//Update map items
			let filteredMarkes = [];
			markers.forEach(marker => {
				if (marker.tags) {
					tags.forEach(id => {
						if (String(marker.tags).replace(',', ' ').search('\\b' + id + '\\b') >= 0) {
							filteredMarkes.push(marker);
						}
					});
				}
			});
			if (filteredMarkes.length > 0) {
				moya.map.activeMarkers = moya.map.addMarkers(filteredMarkes, map, map.options);
			}
		}
		else {
			$('.map__list .item').removeClass('hidden');
			moya.map.activeMarkers = moya.map.addMarkers(moya.map.osmMap.options.markers, map, map.options);
		}
		site.map.fitBounds();
		site.map.showMap();
	},

	showMap: function() {
		$('.map__wrap').removeClass('loading');
	},

	fitBounds: function(zoomLevel) {
		const map = moya.map.osmMap;
		const markers = moya.map.activeMarkers;
		let positions = [];
		for (let i = 0; i < markers.length; i++) {
			positions.push(markers[i].getLatLng());
		}
		let bound = L.latLngBounds(positions);
		if (zoomLevel !== undefined) {
			map.setZoom(zoomLevel);
		}
		map.setView(bound.getCenter());
		map.fitBounds(bound);
	},

	initByGpx(gpx) {
		let map = moya.map.osmMap;
		new L.GPX(gpx, {
			async: true,
			polyline_options: {
				color: '#EA571B',
				weight: 4,
				lineCap: 'round'
			},
			marker_options: {
				startIconUrl: '/static/local/ext-mas/map/pin-icon-start.png',
				endIconUrl: '/static/local/ext-mas/map/pin-icon-end.png',
				shadowUrl: '/static/local/ext-mas/map/pin-shadow.png',
				wptIconUrls : {
					'': '',
				},
				wptIconTypeUrls : {
					'': '',
				},
			}
		}).on('loaded', function(e) {
			map.fitBounds(e.target.getBounds());
		}).addTo(map);
	}
};

// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.accessibility.init();
	site.qn.init();
	site.megamenu.sidebar();
	site.carousel.init();
	site.svg.init();

	$(window).load(function() {
		site.megamenu.seeAll();
		site.map.init();
	});

	var $body = $('body');

	if ($body.is('.formbuilder')) {
		site.fileupload.init('#file');
	}

	if ($body.is('.toy')) {
		site.toyImages.init();
		site.OpenFancyBox.init();
	}

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', 'main,#below').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', 'main').wrap('<div class="table-responsive"></div>');
	}

	const lang = $('#qn #divisions');
	const selected = lang.find('li.selected');
	if (selected.length === 1) {
		lang.find('ul').prepend(lang.find('li.selected'));
	}

	const mobileQn = $('.mobileQn');
	const regions = $('.mobileQn .qn__regions-title');
	regions.click(function(e) {
		mobileQn.toggleClass('open');
	});

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});

MoyaAutocomplete.prototype.initOptions = function () {
	this.minLength = 3;
	this.delay = 400;
	this.url = '/' + moya.division + '/moya/search/ajax/autocomplete';
	this.fetchOpts = {};
	this.cssClassWaiting = 'search__wait';
	this.cssClassEmpty = 'search__empty';
	this.shouldAddType = false;
};

MoyaAutocomplete.prototype.createResultItemLabel = function(data, linkElement) {
	const wrap = document.createElement('div');
	wrap.classList.add('result__wrap');
	const content = document.createElement('div');
	content.classList.add('result__content');
	content.textContent = data.content;
	const subTitle = document.createElement('span');
	subTitle.classList.add('result__subtitle');
	if (data.value.type === 'Extras') {
		subTitle.textContent = data.value.tags[data.value.tags.length - 1];
	}
	else if (data.value.type === 'Toy') {
		subTitle.textContent = '';
	}
	else {
		subTitle.textContent = data.value.type;
	}
	const label = document.createElement('span');
	label.classList.add('result__label');
	const title = document.createElement('span');
	title.classList.add('result__title');
	title.textContent = data.label;
	wrap.appendChild(label);
	wrap.appendChild(content);
	if (subTitle.textContent !== '') {
		label.appendChild(subTitle);

	}
	label.appendChild(title);
	linkElement.appendChild(wrap);
};
